import { getStorageValue } from '@lingoda/utils';
import { REFRESH_TOKEN } from './constants';

export default () => getStorageValue(REFRESH_TOKEN) as unknown as Promise<string | undefined>;
